import {
  FETCH_SELECT_FINDING_RULE_SUCCESS,
  FETCH_SELECT_FINDING_RULE_FAILURE,
  FETCH_SCOPED_FINDING_RULE_TO_DELETE_SUCCESS,
  FETCH_SCOPED_FINDING_RULE_TO_DELETE_FAILURE,
  CREATE_NEW_FINDING_RULE_SUCCESS,
  CREATE_NEW_FINDING_RULE_FAILURE,
  DELETE_FINDING_RULE_SUCCESS,
  DELETE_FINDING_RULE_FAILURE,
  EDIT_FINDING_RULE_SUCCESS,
  EDIT_FINDING_RULE_FAILURE,
  FETCH_FINDING_RULE_REQUEST,
  FETCH_SELECT_FINDING_FIELD_FAILURE,
  FETCH_SELECT_FINDING_FIELD_SUCCESS,
} from "../_constants";

const initialState = {
  loading: false,
  selectFindingRule: "",
  scopeFinding: "",
  // editFinding:false,
  error: "",
  selectFindingField: "",
};

export const selectFindingRuleReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FINDING_RULE_REQUEST:
      return {
        ...state,
        loading: true,
        selectFindingRule: '',
        error: "",
      };
    case FETCH_SELECT_FINDING_RULE_SUCCESS:
      return {
        ...state,
        loading: false,
        selectFindingRule: action.payload,
        error: "",
      };
    case FETCH_SELECT_FINDING_RULE_FAILURE:
      return {
        ...state,
        loading: false,
        selectFindingRule: "",
        error: action.payload,
      };
    case FETCH_SCOPED_FINDING_RULE_TO_DELETE_SUCCESS:
      return {
        ...state,
        scopeFinding: action.payload,
        error: "",
      };
    case FETCH_SCOPED_FINDING_RULE_TO_DELETE_FAILURE:
      return {
        ...state,
        scopeFinding: "",
        error: action.payload,
      };
    case CREATE_NEW_FINDING_RULE_SUCCESS:
      return {
        ...state,
        error: "",
      };
    case CREATE_NEW_FINDING_RULE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_FINDING_RULE_SUCCESS:
      return {
        ...state,
      };
    case DELETE_FINDING_RULE_FAILURE:
      return {
        ...state,
      };
    case EDIT_FINDING_RULE_SUCCESS:
      return {
        ...state,
        // editFinding:true,
        error: "",
      };
    case EDIT_FINDING_RULE_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case FETCH_SELECT_FINDING_FIELD_SUCCESS:
      return {
        ...state,
        selectFindingField: action.payload,
        error: "",
      };
    case FETCH_SELECT_FINDING_FIELD_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};
